 import { AddressAutocomplete } from '@/features/producer-editor/components/AddressAutocomplete';
 import { GeocodeCandidate } from '@/features/producer-editor/hooks/useAddressSearch';
 import { matchRegion } from '@/features/producer-editor/utils/matchRegion';
 import { MapPin } from 'lucide-react';
 
 interface PlaceAddressAutocompleteProps {
   addressValue: string;
   onAddressChange: (value: string) => void;
   onAddressSelect: (data: {
     address_text: string;
     municipality: string | null;
     county: string | null;
     landskap: string | null;
     lat: number;
     lng: number;
   }) => void;
   lat?: number | null;
   lng?: number | null;
 }
 
 export function PlaceAddressAutocomplete({
   addressValue,
   onAddressChange,
   onAddressSelect,
   lat,
   lng,
 }: PlaceAddressAutocompleteProps) {
   const handleSelect = (candidate: GeocodeCandidate) => {
     // Build a formatted address from street + city
     const parts: string[] = [];
     if (candidate.street) parts.push(candidate.street);
     if (candidate.city) parts.push(candidate.city);
     const formattedAddress = parts.length > 0 ? parts.join(', ') : candidate.label;
 
     // Map county to landskap
     const landskap = matchRegion(candidate.county);
 
     onAddressSelect({
       address_text: formattedAddress,
       municipality: candidate.city || null,
       county: candidate.county || null,
       landskap,
       lat: candidate.lat,
       lng: candidate.lng,
     });
 
     // Also update the address input value
     onAddressChange(formattedAddress);
   };
 
   const hasCoordinates = lat != null && lng != null;
 
   return (
     <div className="space-y-2">
       <AddressAutocomplete
         value={addressValue}
         onChange={onAddressChange}
         onSelect={handleSelect}
         placeholder="Sök adress eller platsnamn..."
         id="place-address-search"
       />
       
       {hasCoordinates && (
         <div className="flex items-center gap-2 text-sm text-muted-foreground bg-muted/50 px-3 py-2 rounded-md">
           <MapPin className="h-4 w-4" />
           <span>
             Koordinater: {lat?.toFixed(5)}, {lng?.toFixed(5)}
           </span>
         </div>
       )}
     </div>
   );
 }